import { IconPropsType } from '..';

export const StarIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.3 5.49452L8.77034 5.10392L7.00004 0.933319L5.23604 5.11022L0.700043 5.49452L4.13984 8.47442L3.10664 12.9033L7.00004 10.5534L10.8934 12.9033L9.86654 8.47442L13.3 5.49452ZM7.00004 9.18632L4.83032 10.4992L5.4074 8.02964L3.49094 6.3677L6.01976 6.14846L7.00004 3.8225L7.98662 6.1535L10.5154 6.37274L8.59898 8.03594L9.17606 10.5055L7.00004 9.18632Z"
      fill="currentColor"
    />
  </svg>
);
